import * as React from 'react';

function SvgShareIos(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={24} height={24} viewBox="0 0 24 24" {...props}>
      <path
        fillRule="evenodd"
        d="M11.56 4.82l-1.8 1.74-1.04-1.08 3.07-2.97.52-.51.52.5L14.36 4l1.54 1.48-1.05 1.08-1.53-1.49-.26-.25v11.42h-1.5V4.82zM9.24 7.93H4V21.2h16.62V7.93h-5.25v1.8h3.45v9.67H5.8V9.73h3.44v-1.8z"
      />
    </svg>
  );
}

export default SvgShareIos;
